import { http } from './http'
import type { Rights } from '@/modules/Inventory/utils/accessControl'

// Role-scoped per-operation rights for an entity (Authorize microservice).
const CHECK_MENU_RIGHTS_URL =
  '/PlatformCoreServices/Authorize/EntityOperationsDeptRoleMap/CheckMenuRights'

interface EntityOperation {
  OperationName: string
  OperationID: number
  IsActive: boolean
}

const NO_RIGHTS: Rights = { Create: false, Update: false, Read: false, Delete: false }

/**
 * Fetches the current role's per-operation rights for a given entity from
 * `Authorize/EntityOperationsDeptRoleMap/CheckMenuRights?EntityId=<id>` and maps
 * the active operations into a `Rights` object. Returns all-false on any error.
 */
export async function getEntityRights(entityId: number): Promise<Rights> {
  try {
    const res = await http.get<{ result: EntityOperation[] }>(CHECK_MENU_RIGHTS_URL, {
      params: { EntityId: entityId }
    })
    const operations = Array.isArray(res?.result) ? res.result : []
    const isActive = (name: string) =>
      operations.some((o) => o.OperationName === name && o.IsActive)
    return {
      Create: isActive('Create'),
      Update: isActive('Update'),
      Read: isActive('Read'),
      Delete: isActive('Delete')
    }
  } catch (e) {
    console.error('getEntityRights: failed for entity', entityId, e)
    return { ...NO_RIGHTS }
  }
}
